import React from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import asCoHeader from "../../../../../Images/BidHeaders/asCoHeader.jpg";
import asNwHeader from "../../../../../Images/BidHeaders/asNwHeader.jpg";
import asTfHeader from "../../../../../Images/BidHeaders/asTfHeader.jpg";

const styles = StyleSheet.create({
    headerContainer: {
        marginLeft: -15,
        marginRight: -15,
        marginTop: -15,
        marginBottom: 20,
        position: 'relative',
    },
    headerImage: {
        width: '100%',
        height: 125,
    },
    customerInfo: {
        padding: 8,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#cccccc',
        borderRadius: 5,
        marginTop: 10,
        marginLeft: 35,
        marginRight: 35,
        position: 'relative',
    },
    topRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 6,
    },
    middleRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 6,
    },
    bottomRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    topRowItem: { width: '32%' },
    middleRowItem: { width: '32%' },
    bottomRowItem: { width: '32%' },
    label: {
        fontSize: 10,
        fontFamily: 'Helvetica-Bold',
    },
    value: {
        fontSize: 10,
        fontFamily: 'Helvetica',
    },
    sheetId: {
        position: 'absolute',
        top: 25,
        right: 20,
        fontSize: 8,
        fontFamily: 'Helvetica-Bold',
        color: '#000000',
        backgroundColor: '#f6e3c3',
        padding: 3,
        borderRadius: 2,
    },
});

const getHeaderImage = (company: string) => {
    if (company === 'Agri-Stor Company North West') {
        return asNwHeader;
    } else if (company === 'Agri-Stor Company Colorado') {
        return asCoHeader;
    }
    return asTfHeader;
}

const PdfHeader = ({ company, sheet }: { company: string; sheet: any }) => {
    const headerImage = getHeaderImage(company);

    return (
        <View style={styles.headerContainer} fixed>
            {headerImage && (
                <View>
                    <Image style={styles.headerImage} src={headerImage} />
                    <Text style={styles.sheetId}>{sheet.id}</Text>
                </View>
            )}
            <View render={({ pageNumber }: { pageNumber: number }) => (
                pageNumber === 1 ? (
                    <View style={styles.customerInfo}>
                        <View style={styles.topRow}>
                            <View style={styles.topRowItem}>
                                <Text>
                                    <Text style={styles.label}>Customer:</Text>
                                    <Text style={styles.value}>{sheet.customer || sheet.customerName}</Text>
                                </Text>
                            </View>
                            <View style={styles.topRowItem}>
                                <Text>
                                    <Text style={styles.label}>Creator:</Text>
                                    <Text style={styles.value}>{sheet.creator}</Text>
                                </Text>
                            </View>
                            <View style={styles.topRowItem}>
                                <Text>
                                    <Text style={styles.label}>Date Serviced:</Text>
                                    <Text style={styles.value}>{new Date(sheet.dateServiced).toLocaleDateString('en-US', { timeZone: 'UTC' })}</Text>
                                </Text>
                            </View>
                        </View>
                        <View style={styles.middleRow}>
                            <View style={styles.middleRowItem}>
                                <Text>
                                    <Text style={styles.label}>Storage:</Text>
                                    <Text style={styles.value}>{sheet.locationName || sheet.location}</Text>
                                </Text>
                            </View>
                            <View style={styles.middleRowItem}>
                                <Text>
                                    <Text style={styles.label}>PO:</Text>
                                    <Text style={styles.value}>{sheet.po}</Text>
                                </Text>
                            </View>
                            <View style={styles.middleRowItem}>
                                <Text>
                                    <Text style={styles.label}>Requested By:</Text>
                                    <Text style={styles.value}>{sheet.requestedBy}</Text>
                                </Text>
                            </View>
                        </View>
                        {sheet.isAgreement && <View style={styles.bottomRow}>
                            <View style={styles.bottomRowItem}>
                                <Text>
                                    <Text style={styles.label}>Bay:</Text>
                                    <Text style={styles.value}>{sheet.bayName}</Text>
                                </Text>
                            </View>
                            <View style={styles.bottomRowItem}>
                                <Text>
                                    <Text style={styles.label}>Billing Customer:</Text>
                                    <Text style={styles.value}>{sheet.billing}</Text>
                                </Text>
                            </View>
                            <View style={styles.bottomRowItem}>
                                {/* Intentional spacer to preserve column alignment */}
                                <Text></Text>
                            </View>
                        </View>}
                    </View>
                ) : null
            )} />
        </View>
    );
}

export default PdfHeader;
